import {
  Avatar,
  Box,
  Button,
  Container,
  Divider,
  Grid,
  IconButton,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RouteUrls } from "../../../Constants/RouteUrls";
import { registrationFormData } from "./Data";
import { FormDataType } from "DataTypes/Form";
import { commonFormSwitch, ControlledBoxSizeSwitch } from "Utils/SwitchCases";
import { HandleFormChange } from "Utils/Common";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ControlledForm from "Components/ControlledForm";
import authApi from "Service/Auth.api";
import ImgPath from "Constants/Imgs";
import { OrgDropArr } from "Constants/Arrays";

const CustomerRegister = () => {
  const navigate = useNavigate();
  const urlPath = window.location.pathname;
  console.log(urlPath, "URLPATH");
  const isCorporate = urlPath.includes(RouteUrls.corporate);
  const [otpLoadingType, setOtpLoadingType] = useState<"email" | "contact" | null>(null);
  const [formData, setFormData] = useState<FormDataType[]>([]);
  const [emailData, setEmailData] = useState<{
    fieldVal: string;
    otpSend: boolean;
    otpVal: string;
    otpVerified: boolean;
  }>({
    fieldVal: "",
    otpSend: false,
    otpVal: "",
    otpVerified: false,
  });
  const [contactData, setContactData] = useState<{
    fieldVal: string;
    otpSend: boolean;
    otpVal: string;
    otpVerified: boolean;
  }>({
    fieldVal: "",
    otpSend: false,
    otpVal: "",
    otpVerified: false,
  });
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  // useEffect(() => {
  //   const newArr = JSON.parse(JSON.stringify(registrationFormData()));
  //   if (isCorporate) {
  //     newArr.push({
  //       id: "organization",
  //       label: "Organization",
  //       // boxType: "single-select-drop",
  //       boxType: "input-box",

  //       // validatetype: "dropdown",
  //       validatetype: "name",

  //       boxSize: 3,
  //       dropArr: OrgDropArr,
  //       placeholder: "Select Organization",
  //     });
  //   }
  //   setFormData(newArr);
  // }, []);

  useEffect(() => {
    const fetchOrgs = async () => {
      if (!isCorporate) {
        setFormData(registrationFormData());
        return;
      }

      try {
        const res = await authApi.getOrganizations();
        const OrgDropArr = res?.data || [];

        const newArr = JSON.parse(JSON.stringify(registrationFormData()));

        newArr.push({
          id: "organization",
          label: "Organization",
          boxType: "autocomplete",
          dropArr: OrgDropArr,
          placeholder: "Type or Select Organization",
          value: "",
        });

        setFormData(newArr);
      } catch (error) {
        console.error("Failed to fetch organizations:", error);
        setFormData(registrationFormData());
      }
    };
    fetchOrgs();
  }, [isCorporate]);

  // const handleSendOtp: (otpType: "email" | "contact") => void = async (
  //   otpType
  // ) => {
  //   if (otpType == "email") {

  //     // 1. Check if email is empty
  //   if (!emailData.fieldVal || emailData.fieldVal.trim() === "") {
  //     alert("Please enter a valid email address first.");
  //     return;
  //   }
  //   // 2. Simple regex check (optional but recommended)
  //   if (!/\S+@\S+\.\S+/.test(emailData.fieldVal)) {
  //     alert("Please enter a valid email format.");
  //     return;
  //   }

  //     const res = await authApi.emailSendOtp({
  //       email: emailData.fieldVal,
  //       requestType: "register",
  //     });
  //     if (res?.success) {
  //       setEmailData({
  //         fieldVal: emailData.fieldVal,
  //         otpSend: true,
  //         otpVal: "",
  //         otpVerified: false,
  //       });
  //     }
  //   } else {

  //     // 1. Check if contact is empty
  //   if (!contactData.fieldVal || contactData.fieldVal.trim() === "") {
  //     alert("Please enter your contact number first.");
  //     return;
  //   }
  //   // 2. Check for minimum length (e.g., 10 digits)
  //   if (contactData.fieldVal.length < 10) {
  //     alert("Please enter a valid 10-digit contact number.");
  //     return;
  //   }
  //     const res = await authApi.mobileSendOtp({
  //       mobileNumber: contactData.fieldVal,
  //       requestType: "register",
  //     });
  //     if (res?.success) {
  //       setContactData({
  //         fieldVal: contactData.fieldVal,
  //         otpSend: true,
  //         otpVal: "",
  //         otpVerified: false,
  //       });
  //     }
  //   }
  // };
  

const handleSendOtp: (otpType: "email" | "contact") => void = async (otpType) => {
  if (otpLoadingType) return;

  if (otpType === "email") {
   
    // 1. Validation for Email
    if (!emailData.fieldVal || emailData.fieldVal.trim() === "") {
      alert("Please enter a valid email address first.");
      return;
    }
    if (!/\S+@\S+\.\S+/.test(emailData.fieldVal)) {
      alert("Please enter a valid email format.");
      return;
    }

     setOtpLoadingType("email"); // Set loading for email only
    try {
      const res = await authApi.emailSendOtp({
        email: emailData.fieldVal,
        requestType: "register",
      });
      if (res?.success) {
        setEmailData({
          ...emailData, // Keep existing field value
          otpSend: true,
          otpVal: "",
          otpVerified: false,
        });
      }
    }
     catch (error) {
      console.error("Email OTP Error:", error);
    } finally {
      setOtpLoadingType(null); // Stop Loader
    }

  } else {
    // 2. Validation for Contact
    if (!contactData.fieldVal || contactData.fieldVal.trim() === "") {
      alert("Please enter your contact number first.");
      return;
    }
    if (contactData.fieldVal.length < 10) {
      alert("Please enter a valid 10-digit contact number.");
      return;
    }
     setOtpLoadingType("contact"); // Set loading for contact only

    try {
      const res = await authApi.mobileSendOtp({
        mobileNumber: contactData.fieldVal,
        requestType: "register",
      });
      if (res?.success) {
        setContactData({
          ...contactData, // Keep existing field value
          otpSend: true,
          otpVal: "",
          otpVerified: false,
        });
      }
    } catch (error) {
      console.error("Mobile OTP Error:", error);
    } finally {
      setOtpLoadingType(null); // Stop Loader
    }
  }
};
  const handleVerifyOtp: (otpType: "email" | "contact") => void = async (
    otpType
  ) => {
    if (otpType === "email") {
      const res = await authApi.verifyOtp({
        mobileNumber: null,
        email: emailData.fieldVal,
        otp: emailData.otpVal,
      });
      if (res?.success) {
        setEmailData({
          fieldVal: emailData.fieldVal,
          otpSend: true,
          otpVal: emailData.otpVal,
          otpVerified: true,
        });
      }
    } else {
      const res = await authApi.verifyOtp({
        mobileNumber: contactData.fieldVal,
        email: null,
        otp: contactData.otpVal,
      });
      if (res?.success) {
        setContactData({
          fieldVal: contactData.fieldVal,
          otpSend: true,
          otpVal: contactData.otpVal,
          otpVerified: true,
        });
      }
    }
  };

  const handleRegister = async () => {
    // Define a default Date of Birth (e.g., 18 years ago)
  const defaultDOB = new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString();

const payload = {
    // 1. DATA FROM USER (Required)
    firstName: formData[0]?.value || "User",
    lastName: formData[1]?.value || "New",
    email: emailData?.fieldVal || "",
    contactNumber: contactData?.fieldVal || "0000000000",
    password: formData[2]?.value || "", 

    // 2. DEFAULT DATA (To prevent Backend [Required] errors)
    address: formData[8]?.value || "Not Provided", // Backend requires Address
    dateOfBirth: formData[6]?.value || defaultDOB, // Backend requires DOB
    
    // 3. OPTIONAL DATA (Empty Strings)
    city: formData[3]?.value || "",
    state: formData[4]?.value || "",
    postalCode: formData[5]?.value || "",
    description: formData[7]?.value || "",
    highestQualification: "",
    profilePicturePath: ""
  };

const res = await authApi.registerUser(payload);
  if (res?.success) {
    navigate(`/${RouteUrls.login}`);
  } else {
    // Log the error to see which field is still failing validation
    console.error("Registration Failed:", res?.errors);
  }
  };
  const handleCorporateRegister = async () => {

    // Define a default Date of Birth (e.g., 18 years ago)
  const defaultDOB = new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString();

    const payload = {
     // Required / Basic fields with fallback to empty string
    firstName: formData[0]?.value ?? "",
    lastName: formData[1]?.value ?? "",
    password: formData[2]?.value ?? "",
    // corporateOrg: formData[3]?.value ?? "",
    // Ensure this sends the typed string OR selected ID
    // If your commonFormSwitch stores the ID in 'value' and typed text in 'value' 
    // when no ID is found, this will work.
    corporateOrg: formData.find(x => x.id === "organization")?.value?.toString() ?? "",
    
    // Optional fields: using ?. ensures it doesn't crash if formData[x] is undefined
    address: formData[7]?.value ?? "Not Provided",
    city: formData[8]?.value ?? "",
    
    // Dropdown fix: Safe access to dropValue
    state: formData[4]?.dropValue ?? "", 
    
    postalCode: formData[5]?.value ?? "",
    dateOfBirth: formData[6]?.value ?? defaultDOB,
    
    // Corporate Specific
    
    highestQualification: "",
    profilePicturePath: "",
    email: emailData?.fieldVal ?? "",
    contactNumber: contactData?.fieldVal ?? "",
      // userType: "User",
    };

    console.log("Sending Payload:", payload);

    const res = await authApi.registerCorporateUser(payload);
    if (res?.success) {
    navigate(`/${RouteUrls.login}`);
    }
  };

  const handlePasswordToggle = (fieldId: string) => {
    setFormData((prev) =>
      prev.map((field) =>
        field.id === fieldId
          ? { ...field, showPassword: !field.showPassword }
          : field
      )
    );
  };

  // return (
  //   <Box sx={{ height: "100vh", overflow: "auto" }}>
  //     <Box
  //       sx={{
  //         display: "flex",
  //         alignItems: "center",
  //         justifyContent: "space-between",
  //         px: 3,
  //         py: 1,
  //         borderBottom: "1px solid #e0e0e0",
  //       }}
  //     >
  //       <Box
  //         component="img"
  //         src={"https://nolegalpaisa.com/assets/images/nlp_logo.png"}
  //         alt="Logo"
  //         sx={{
  //           width: { xs: "150px", sm: "200px", md: "230px" },
  //           height: { xs: "60px", sm: "80px", md: "83px" },
  //           objectFit: "contain",
  //           cursor: "pointer",
  //           filter: "drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.3))",
  //           transition: "transform 0.2s ease-in-out",
  //           "&:hover": {
  //             transform: "scale(1.05)",
  //           },
  //         }}
  //         onClick={() => (window.location.href = "/home.html")}
  //       />
  //       <Typography
  //         component="h1"
  //         variant="h4"
  //         sx={{
  //           flex: 1,
  //           textAlign: "center",
  //           color: "primary.main",
  //           fontWeight: 600,
  //           display: "flex",
  //           alignItems: "center",
  //           justifyContent: "center",
  //           gap: 1,
  //         }}
  //       >
  //         <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
  //           <LockOutlinedIcon />
  //         </Avatar>
  //         {isCorporate ? "Sign Up as Corporate" : "Sign Up"}
  //       </Typography>
  //       <Box sx={{ width: "180px" }} /> {/* Spacer to balance the layout */}
  //     </Box>
  //     <Grid
  //       container
  //       component="main"
  //       sx={{ flex: 1 }}
  //       alignItems="center"
  //       justifyContent="center"
  //     >
  //       {!isSmallScreen && (
  //         <Grid
  //           sx={{
  //             backgroundImage: 'url("/images/signup-bg.jpg")',
  //             backgroundRepeat: "no-repeat",
  //             backgroundSize: "cover",
  //             backgroundPosition: "center",
  //             height: "100%",
  //           }}
  //         />
  //       )}
  //       <Grid
  //         sx={{
  //           display: "flex",
  //           alignItems: "center",
  //           justifyContent: "center",
  //           py: 4,
  //         }}
  //       >
  //         <Box
  //           sx={{
  //             mx: 4,
  //             width: "100%",
  //             display: "flex",
  //             flexDirection: "column",
  //             alignItems: "center",
  //           }}
  //         >
  //           <Box component="form" noValidate sx={{ mt: 1, width: "100%" }}>
  //             <Grid mb={2} container columnSpacing={2} rowSpacing={2}>
  //               {formData.length > 0 &&
  //                 formData.map((el: FormDataType) => (
  //                   <Grid
  //                     key={el.id}
  //                     size={{ ...ControlledBoxSizeSwitch(el.boxSize) }}
  //                   >
  //                     {commonFormSwitch({
  //                       formObj: {
  //                         ...el,
  //                         onPasswordToggle: el.hasPasswordToggle
  //                           ? () => handlePasswordToggle(el.id)
  //                           : undefined,
  //                       },
  //                       onChange: (data) =>
  //                         setFormData(HandleFormChange(data, formData)),
  //                     })}
  //                   </Grid>
  //                 ))}
  //             </Grid>

  //             <Grid container columnSpacing={2} rowSpacing={2}>
  //               <Grid key={"email"} size={{ ...ControlledBoxSizeSwitch(3) }}>
  //                 <ControlledForm.Input
  //                   id="email"
  //                   value={emailData.fieldVal}
  //                   label="Email"
  //                   {...(emailData.otpVerified && {
  //                     focused: true,
  //                     borderColor: "success",
  //                     readOnly: true,
  //                   })}
  //                   onChange={(value) =>
  //                     setEmailData({ ...emailData, fieldVal: value as string })
  //                   }
  //                 />
  //               </Grid>
  //               <Grid
  //                 key={"email"}
  //                 sx={{ display: emailData.otpSend == true ? "block" : "none" }}
  //                 size={{ ...ControlledBoxSizeSwitch(3) }}
  //               >
  //                 <ControlledForm.Input
  //                   id="emailOtp"
  //                   label="Email OTP"
  //                   {...(emailData.otpVerified && {
  //                     iconId: "check-icon",
  //                     infoText: "Email Verified",
  //                     readOnly: true,
  //                   })}
  //                   value={emailData.otpVal}
  //                   onChange={(value) =>
  //                     setEmailData({ ...emailData, otpVal: value as string })
  //                   }
  //                 />
  //               </Grid>
  //               <Grid key={"email"} size={{ ...ControlledBoxSizeSwitch(3) }}>
  //                 <Button
  //                   // fullWidth
  //                   variant="contained"
  //                   sx={{ mt: 3 }}
  //                   onClick={() =>
  //                     emailData.otpSend
  //                       ? handleVerifyOtp("email")
  //                       : handleSendOtp("email")
  //                   }
  //                   disabled={emailData.otpVerified}
  //                 >
  //                   {emailData.otpSend === true ? "Verify" : "Send OTP"}
  //                 </Button>
  //                 <IconButton
  //                   sx={{ mt: 3 }}
  //                   title="Reset"
  //                   onClick={() =>
  //                     setEmailData(
  //                       JSON.parse(
  //                         JSON.stringify({
  //                           fieldVal: "",
  //                           otpSend: false,
  //                           otpVal: "",
  //                           otpVerified: false,
  //                         })
  //                       )
  //                     )
  //                   }
  //                 >
  //                   <ImgPath.RestoreIcon />
  //                 </IconButton>
  //               </Grid>
  //             </Grid>

  //             <Grid mt={2} container columnSpacing={2} rowSpacing={2}>
  //               <Grid key={"contact"} size={{ ...ControlledBoxSizeSwitch(3) }}>
  //                 <ControlledForm.Input
  //                   id="contact"
  //                   value={contactData.fieldVal}
  //                   {...(contactData.otpVerified && {
  //                     focused: true,
  //                     borderColor: "success",
  //                     readOnly: true,
  //                   })}
  //                   label="Contact"
  //                   onChange={(value) =>
  //                     setContactData({
  //                       ...contactData,
  //                       fieldVal: value as string,
  //                     })
  //                   }
  //                 />
  //               </Grid>
  //               <Grid
  //                 key={"contactOtp"}
  //                 sx={{
  //                   display: contactData.otpSend === true ? "block" : "none",
  //                 }}
  //                 size={{ ...ControlledBoxSizeSwitch(3) }}
  //               >
  //                 <ControlledForm.Input
  //                   id="contactOtp"
  //                   value={contactData.otpVal}
  //                   label="Contact OTP"
  //                   readOnly={contactData.otpVerified}
  //                   {...(contactData.otpVerified && {
  //                     iconId: "check-icon",
  //                     infoText: "Contact Number Verified",
  //                   })}
  //                   onChange={(value) =>
  //                     setContactData({
  //                       ...contactData,
  //                       otpVal: value as string,
  //                     })
  //                   }
  //                 />
  //               </Grid>
  //               <Grid key={"contact"} size={{ ...ControlledBoxSizeSwitch(3) }}>
  //                 <Button
  //                   // fullWidth
  //                   variant="contained"
  //                   sx={{ mt: 3 }}
  //                   onClick={() =>
  //                     contactData.otpSend
  //                       ? handleVerifyOtp("contact")
  //                       : handleSendOtp("contact")
  //                   }
  //                   disabled={contactData.otpVerified}
  //                 >
  //                   {contactData.otpSend === true ? "Verify" : "Send OTP"}
  //                 </Button>
  //                 <IconButton
  //                   sx={{ mt: 3 }}
  //                   title="Reset"
  //                   onClick={() =>
  //                     setContactData(
  //                       JSON.parse(
  //                         JSON.stringify({
  //                           fieldVal: "",
  //                           otpSend: false,
  //                           otpVal: "",
  //                           otpVerified: false,
  //                         })
  //                       )
  //                     )
  //                   }
  //                 >
  //                   <ImgPath.RestoreIcon />
  //                 </IconButton>
  //               </Grid>
  //             </Grid>

  //             <Button
  //               variant="contained"
  //               sx={{ mt: 3 }}
  //               onClick={isCorporate ? handleCorporateRegister : handleRegister}
  //               disabled={!emailData.otpVerified && !contactData.otpVerified}
  //             >
  //               Sign Up
  //             </Button>

  //             <Typography
  //               sx={{
  //                 textAlign: "center",
  //                 textDecoration: "underline",
  //                 cursor: "pointer",
  //                 mt: 2,
  //               }}
  //               variant="body2"
  //               onClick={() => navigate(`/${RouteUrls.login}`)}
  //             >
  //               Already have an account? Login
  //             </Typography>
  //           </Box>
  //         </Box>
  //       </Grid>
  //     </Grid>
  //   </Box>
  // );



// ... existing imports (LockOutlinedIcon, ImgPath, etc.)


// ... existing imports (LockOutlinedIcon, ImgPath, etc.)

// return (
//   <Box sx={{ height: "100vh", overflow: "hidden", display: "flex", flexDirection: "column" }}>
//     {/* --- HEADER --- */}
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "space-between",
//         px: 3,
//         py: 1,
//         borderBottom: "1px solid #e0e0e0",
//         bgcolor: "background.paper",
//         zIndex: 10
//       }}
//     >
//       <Box
//         component="img"
//         src={"https://nolegalpaisa.com/assets/images/nlp_logo.png"}
//         alt="Logo"
//         sx={{
//           width: { xs: "150px", sm: "200px", md: "230px" },
//           height: "auto",
//           objectFit: "contain",
//           cursor: "pointer",
//         }}
//         onClick={() => (window.location.href = "/home.html")}
//       />
//       <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//         <Avatar sx={{ bgcolor: "primary.main", width: 32, height: 32 }}>
//           <LockOutlinedIcon sx={{ fontSize: 18 }} />
//         </Avatar>
//         <Typography variant="h6" fontWeight={600} color="primary">
//           {isCorporate ? "Corporate Sign Up" : "Sign Up"}
//         </Typography>
//       </Box>
//       <Box sx={{ width: "230px", display: { xs: "none", md: "block" } }} />
//     </Box>

//     {/* --- MAIN CONTENT --- */}
//     <Grid container sx={{ flex: 1, overflow: "hidden" }}>
//       {/* Image Side */}
//       {!isSmallScreen && (
//         <Grid
//           size={{ sm: 4, md: 7 }}
//           sx={{
//             backgroundImage: 'url("/images/signup-bg.jpg")',
//             backgroundRepeat: "no-repeat",
//             backgroundSize: "cover",
//             backgroundPosition: "center",
//           }}
//         />
//       )}

//       {/* Form Side */}
//       <Grid
//         size={{ xs: 12, sm: 8, md: 5 }}
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           overflowY: "auto",
//           bgcolor: "#fafafa"
//         }}
//       >
//         <Box sx={{ width: "100%", maxWidth: 500, p: 4, my: "auto" }}>
//           <Typography variant="h4" fontWeight={800} gutterBottom>
//             Get Started
//           </Typography>
//           <Typography variant="body2" color="text.secondary" mb={4}>
//             Join NoLegalPaisa to manage your legal needs efficiently.
//           </Typography>

//           <Box component="form" noValidate>
//             <Grid container spacing={2}>
//               {/* Dynamic Fields */}
//               {formData.length > 0 &&
//                 formData.map((el: FormDataType) => (
//                   <Grid
//                     key={el.id}
//                     size={{ ...ControlledBoxSizeSwitch(el.boxSize) }}
//                   >
//                     {commonFormSwitch({
//                       formObj: {
//                         ...el,
//                         onPasswordToggle: el.hasPasswordToggle
//                           ? () => handlePasswordToggle(el.id)
//                           : undefined,
//                       },
//                       onChange: (data) =>
//                         setFormData(HandleFormChange(data, formData)),
//                     })}
//                   </Grid>
//                 ))}

//               {/* Email Section */}
//               <Grid size={emailData.otpSend ? 7 : 9}>
//                 <ControlledForm.Input
//                   id="email"
//                   label="Email"
//                   value={emailData.fieldVal}
//                   {...(emailData.otpVerified && { focused: true, borderColor: "success", readOnly: true })}
//                   onChange={(value) => setEmailData({ ...emailData, fieldVal: value as string })}
//                 />
//               </Grid>
//               {emailData.otpSend && (
//                 <Grid size={2}>
//                   <ControlledForm.Input
//                     id="emailOtp"
//                     label="OTP"
//                     value={emailData.otpVal}
//                     {...(emailData.otpVerified && { readOnly: true })}
//                     onChange={(value) => setEmailData({ ...emailData, otpVal: value as string })}
//                   />
//                 </Grid>
//               )}
//               <Grid size={3} sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Button
//                   fullWidth
//                   variant="contained"
//                   sx={{ height: '56px', textTransform: 'none' }}
//                   onClick={() => emailData.otpSend ? handleVerifyOtp("email") : handleSendOtp("email")}
//                   disabled={emailData.otpVerified}
//                 >
//                   {emailData.otpSend ? "Verify" : "Send"}
//                 </Button>
//                 <IconButton size="small" onClick={() => setEmailData({ fieldVal: "", otpSend: false, otpVal: "", otpVerified: false })}>
//                   <ImgPath.RestoreIcon />
//                 </IconButton>
//               </Grid>

//               {/* Contact Section */}
//               <Grid size={contactData.otpSend ? 7 : 9}>
//                 <ControlledForm.Input
//                   id="contact"
//                   label="Contact"
//                   value={contactData.fieldVal}
//                   {...(contactData.otpVerified && { focused: true, borderColor: "success", readOnly: true })}
//                   onChange={(value) => setContactData({ ...contactData, fieldVal: value as string })}
//                 />
//               </Grid>
//               {contactData.otpSend && (
//                 <Grid size={2}>
//                   <ControlledForm.Input
//                     id="contactOtp"
//                     label="OTP"
//                     value={contactData.otpVal}
//                     {...(contactData.otpVerified && { readOnly: true })}
//                     onChange={(value) => setContactData({ ...contactData, otpVal: value as string })}
//                   />
//                 </Grid>
//               )}
//               <Grid size={3} sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Button
//                   fullWidth
//                   variant="contained"
//                   sx={{ height: '56px', textTransform: 'none' }}
//                   onClick={() => contactData.otpSend ? handleVerifyOtp("contact") : handleSendOtp("contact")}
//                   disabled={contactData.otpVerified}
//                 >
//                   {contactData.otpSend ? "Verify" : "Send"}
//                 </Button>
//                 <IconButton size="small" onClick={() => setContactData({ fieldVal: "", otpSend: false, otpVal: "", otpVerified: false })}>
//                   <ImgPath.RestoreIcon />
//                 </IconButton>
//               </Grid>
//             </Grid>

//             <Button
//               fullWidth
//               variant="contained"
//               size="large"
//               sx={{ mt: 4, py: 1.5, borderRadius: 2, fontWeight: 700 }}
//               onClick={isCorporate ? handleCorporateRegister : handleRegister}
//               disabled={!emailData.otpVerified && !contactData.otpVerified}
//             >
//               Sign Up
//             </Button>

//             <Typography
//               sx={{ textAlign: "center", mt: 3, cursor: "pointer", fontWeight: 500 }}
//               variant="body2"
//               onClick={() => navigate(`/${RouteUrls.login}`)}
//             >
//               Already have an account? <span style={{ color: "#1976d2" }}>Login</span>
//             </Typography>
//           </Box>
//         </Box>
//       </Grid>
//     </Grid>
//   </Box>
// );



// ... existing imports (LockOutlinedIcon, ImgPath, etc.)

return (
  <Box 
    sx={{ 
      minHeight: "100vh", 
      display: "flex", 
      flexDirection: "column",
      background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
      overflowY: "auto"
    }}
  >
    {/* --- MINIMALIST HEADER --- */}
    <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
       <Box
          component="img"
          src={"https://nolegalpaisa.com/assets/images/nlp_logo.png"}
          alt="Logo"
          sx={{ height: "60px", cursor: "pointer" }}
          onClick={() => (window.location.href = "/home.html")}
        />
    </Box>

    <Container maxWidth="sm" sx={{ pb: 8 }}>
      <Paper 
        elevation={0} 
        sx={{ 
          p: { xs: 3, md: 5 }, 
          borderRadius: 6, 
          boxShadow: "0px 20px 50px rgba(0,0,0,0.08)",
          bgcolor: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.3)"
        }}
      >
        {/* --- FORM TITLE --- */}
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Avatar 
            sx={{ 
              m: "0 auto 16px", 
              bgcolor: "primary.main", 
              width: 60, 
              height: 60,
              boxShadow: "0 8px 20px rgba(25, 118, 210, 0.2)"
            }}
          >
            <LockOutlinedIcon fontSize="large" />
          </Avatar>
          <Typography variant="h4" fontWeight={800} sx={{ color: "#1a202c", mb: 1 }}>
            {isCorporate ? "Corporate Account" : "Create Account"}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Join the NoLegalPaisa professional community
          </Typography>
        </Box>

        <Box component="form" noValidate>
          <Grid container spacing={2.5}>
            {/* 1. DYNAMIC FIELDS (Full Name, Password, etc.) */}
            {formData.length > 0 &&
              formData.map((el: FormDataType) => (
                <Grid 
                  key={el.id} 
                  size={{ xs: 12, sm: el.boxSize === 3 ? 6 : 12 }}
                >
                  {commonFormSwitch({
                    formObj: {
                      ...el,
                      onPasswordToggle: el.hasPasswordToggle
                        ? () => handlePasswordToggle(el.id)
                        : undefined,
                    },
                    onChange: (data) =>
                      setFormData(HandleFormChange(data, formData)),
                  })}
                </Grid>
              ))}

            {/* 2. EMAIL VERIFICATION SECTION */}
            <Grid size={12}>
              <Divider sx={{ my: 2 }}>
                <Typography variant="caption" sx={{ fontWeight: 700, color: "text.disabled", textTransform: "uppercase", letterSpacing: 1 }}>
                  Security Verification
                </Typography>
              </Divider>
            </Grid>

            {/* Email Input */}
            <Grid size={emailData.otpSend ? 7 : 9}>
              <ControlledForm.Input
                id="email"
                label="Email Address"
                value={emailData.fieldVal}
                {...((emailData.otpVerified || emailData.otpSend) && { focused: true, borderColor: "success", readOnly: true })}
                onChange={(value) => setEmailData({ ...emailData, fieldVal: value as string })}
              />
            </Grid>
            {emailData.otpSend && (
              <Grid size={2}>
                <ControlledForm.Input
                  id="emailOtp"
                  label="OTP"
                  value={emailData.otpVal}
                  maxLength={4}
                  {...(emailData.otpVerified && { readOnly: true })}
                  onChange={(value) => setEmailData({ ...emailData, otpVal: value as string })}
                />
              </Grid>
            )}
            <Grid size={emailData.otpSend ? 3 : 3} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {/* <Button
                fullWidth
                variant={emailData.otpVerified ? "outlined" : "contained"}
                color={emailData.otpVerified ? "success" : "primary"}
                sx={{ height: '56px', borderRadius: 2, fontWeight: 600 }}
                onClick={() => emailData.otpSend ? handleVerifyOtp("email") : handleSendOtp("email")}
                disabled={emailData.otpVerified}
              >
                {emailData.otpSend ? "Verify" : "OTP"}
              </Button> */}

              <Button
                fullWidth
                variant={emailData.otpVerified ? "outlined" : "contained"}
                color={emailData.otpVerified ? "success" : "primary"}
                sx={{
                  height: '56px',
                  borderRadius: 2,
                  fontWeight: 600,
                  textTransform: 'none' // Keeps it looking modern
                }}
                onClick={() => emailData.otpSend ? handleVerifyOtp("email") : handleSendOtp("email")}
                // Disable if: already verified OR currently loading OR field is empty
                disabled={emailData.otpVerified || otpLoadingType === "email" || !emailData.fieldVal?.trim()}
              >
                {otpLoadingType === "email" ? "Sending..." : emailData.otpVerified ? "Verified ✓" : emailData.otpSend ? "Verify OTP" : "Get OTP"}
                
              </Button>




              <IconButton size="small" onClick={() => setEmailData({ fieldVal: "", otpSend: false, otpVal: "", otpVerified: false })}>
                <ImgPath.RestoreIcon />
              </IconButton>
            </Grid>

            {/* Contact Input */}
            <Grid size={contactData.otpSend ? 7 : 9}>
              <ControlledForm.Input
                id="contact"
                label="Contact Number"
                value={contactData.fieldVal}
                {...((contactData.otpVerified || contactData.otpSend) && { focused: true, borderColor: "success", readOnly: true })}
                onChange={(value) => {
                  const stringValue = value as string;
                  // Only update state if the length is 10 or less
                  if (stringValue.length <= 10) {
                    setContactData({ ...contactData, fieldVal: value as string })
                  }
                }
                }
              />
            </Grid>
            {contactData.otpSend && (
              <Grid size={2}>
                <ControlledForm.Input
                  id="contactOtp"
                  label="OTP"
                  maxLength={4}
                  value={contactData.otpVal}
                  {...(contactData.otpVerified &&  { readOnly: true })}
                  onChange={(value) => setContactData({ ...contactData, otpVal: value as string })}
                />
              </Grid>
            )}
            <Grid size={contactData.otpSend ? 3 : 3} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {/* <Button
                fullWidth
                variant={contactData.otpVerified ? "outlined" : "contained"}
                color={contactData.otpVerified ? "success" : "primary"}
                sx={{ height: '56px', borderRadius: 2, fontWeight: 600 }}
                onClick={() => contactData.otpSend ? handleVerifyOtp("contact") : handleSendOtp("contact")}
                disabled={contactData.otpVerified}
              >
                {contactData.otpSend ? "Verify" : "OTP"}
              </Button> */}
              <Button
                fullWidth
                variant={contactData.otpVerified ? "outlined" : "contained"}
                color={contactData.otpVerified ? "success" : "primary"}
                sx={{
                  height: '56px',
                  borderRadius: 2,
                  fontWeight: 600,
                  textTransform: 'none' // Modern look
                }}
                onClick={() => contactData.otpSend ? handleVerifyOtp("contact") : handleSendOtp("contact")}
                // Disable if: already verified OR currently loading OR contact field is empty/too short
                disabled={contactData.otpVerified || otpLoadingType === "contact" || !contactData.fieldVal?.trim()}
              >
                {otpLoadingType === "contact" ? "Sending..." : contactData.otpVerified ? "Verified ✓" : contactData.otpSend ? "Verify OTP" : "Get OTP"}
                
              </Button>
              <IconButton size="small" onClick={() => setContactData({ fieldVal: "", otpSend: false, otpVal: "", otpVerified: false })}>
                <ImgPath.RestoreIcon />
              </IconButton>
            </Grid>
          </Grid>

          {/* --- FINAL ACTION BUTTON --- */}
          {/* <Button
            fullWidth
            variant="contained"
            size="large"
            sx={{ 
              mt: 6, 
              py: 2, 
              borderRadius: 3, 
              fontSize: "1.1rem", 
              fontWeight: 700,
              textTransform: "none",
              boxShadow: "0 10px 25px rgba(25, 118, 210, 0.25)",
              transition: "0.3s",
              "&:hover": { transform: "translateY(-2px)", boxShadow: "0 15px 30px rgba(25, 118, 210, 0.3)" }
            }}
            onClick={isCorporate ? handleCorporateRegister : handleRegister}
            disabled={!emailData.otpVerified && !contactData.otpVerified}
          >
            Create Account
          </Button> */}

          {/* --- FINAL ACTION BUTTON --- */}
<Button
  fullWidth
  variant="contained"
  size="large"
  sx={{ 
    mt: 6, 
    py: 2, 
    borderRadius: 3, 
    fontSize: "1.1rem", 
    fontWeight: 700,
    textTransform: "none",
    boxShadow: "0 10px 25px rgba(25, 118, 210, 0.25)",
    transition: "0.3s",
    "&:hover": { transform: "translateY(-2px)", boxShadow: "0 15px 30px rgba(25, 118, 210, 0.3)" }
  }}
  onClick={isCorporate ? handleCorporateRegister : handleRegister}
  // FIX: Disable if Email is NOT verified OR Contact is NOT verified
  disabled={!emailData.otpVerified || !contactData.otpVerified}
>
  Create Account
</Button>

          <Box sx={{ mt: 4, textAlign: "center" }}>
            <Typography variant="body2" color="text.primary">
              Already have an account?{" "}
              <Typography 
                component="span" 
                variant="body2" 
                textAlign="center"
                onClick={() => navigate(`/${RouteUrls.login}`)}
                sx={{ 
                  color: "primary.main", 
                  fontWeight: 700, 
                  cursor: "pointer",
                  "&:hover": { textDecoration: "underline" }
                }}
              >
                Sign In
              </Typography>
            </Typography>
          </Box>
        </Box>
      </Paper>
      
      {/* Footer text */}
      <Typography variant="caption" sx={{ display: "block", textAlign: "center", mt: 4, color: "text.disabled" }}>
        Protected by NoLegalPaisa Secure Gateway. © 2025
      </Typography>
    </Container>
  </Box>
);

};

export default CustomerRegister;
